import { FC } from "react";
import { ICellRendererParams } from "ag-grid-community";
import { BudgetsCustomPeriodCell } from "./BudgetsCustomPeriodCell";
import { TooltipText } from "@/components/common/TooltipText";
import { formatDate } from "@/utils/helpers/date-time/datetime-format";
import { capitalizeString } from "@/utils/helpers/capitalizeString";
import { Budget } from "@/services/cloudchipr.api";
import { TypographyWithCopy } from "@/components/common/TypographyWithCopy";

export const BudgetsPeriodCell: FC<ICellRendererParams<Budget>> = ({
  data: budget,
}) => {
  const period = budget?.period;
  const startDate = budget?.start_date;

  if (!period || !startDate) {
    return;
  }

  if (period === "custom") {
    return <BudgetsCustomPeriodCell budget={budget} />;
  }

  return (
    <TooltipText
      tooltipTitle={`Start date: ${formatDate(startDate, { type: "date" })}`}
    >
      <TypographyWithCopy value={capitalizeString(period)} variant="inherit" />
    </TooltipText>
  );
};
